(ns quuppa.qsm.site-plan.view
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [quuppa.components :as c]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.features :as features]
            [quuppa.qsm.site-plan.events :as events]
            [quuppa.qsm.ui-state.events :as state-events]
            [quuppa.qsm.ui-state.subs :as state-subs]
            [quuppa.ui.button :refer [button]]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.spinner :refer [spinner]]
            [quuppa.ui.tabs :as tabs]))

(defn selected-plan [site-plan {:keys [loading?]}]
  ;; TODO: there is no proper metadata available from QCP, only thing we can basically show is Site plan key.
  [:dl.grid.q-cols-4.gap-0
   {:class [(when loading? "placeholder-glow")]}
   (if loading?
     [:<> [:dt.placeholder "Key"] [:dd.g-col-3.placeholder "P"]]
     [:<>
      [:dt.g-col-1 "Key"]
      [:dd.g-col-3 [:code (:key site-plan)]]
      (when-let [site-plan-name (:name site-plan)]
        [:<>
         [:dt.g-col-1 "Name"]
         [:dd.g-col-3 site-plan-name]])])])

(defn side-plan-form-card-item
  "Card component of site-plan data"
  [form-key site-plan current-plan? selection-key]
  (let [site-plan-name      (:name site-plan)
        site-plan-key       (:key site-plan)
        dropdown-menu-items (if current-plan?
                              []
                              []
                              ;; TODO: since sc-28557 site plans are stored in QSM and the meaning of deleting site plan
                              ;; is totally different compared to deleting project folders from QPE data folder...
                              #_[[dropdown/menu
                                [dropdown/item
                                 {:on-click #(rf/dispatch [::events/delete-previous qpe-identity site-plan-name license-key])}
                                 [:div.d-flex.align-items-center
                                  [icon :trash-fill.mr-2.text-danger] "Delete"]]]])
        radio-id            (str "radio-" site-plan-key)]
    [:div.card.my-2.p-2
     [:div.form-check.d-flex.align-items-center
      [:input.form-check-input.flex-shrink-0
       {:type      "radio"
        :id        radio-id
        :on-change (fn [_]
                     (rf/dispatch [::state-events/set-sidebar-form-field :site form-key selection-key site-plan-key]))
        :checked   current-plan?}]
      [:label.form-check-label.flex-grow-1
       {:for radio-id}
       [:span.d-block.text-center
        site-plan-name]
       [:code.d-block.text-center
        site-plan-key]]
      (into [dropdown/dropdown
             [dropdown/menu-icon-toggle {:disabled (empty? dropdown-menu-items)
                                         :class (when (empty? dropdown-menu-items) "invisible")}]]
            dropdown-menu-items)]]))

(defn site-plan-key-form [form-key {:keys [license-key password]} error]
  [:<>
   [:div.form-group
    [:label "Key for submitted Site Plan"]
    [:input.form-control
     {:type  "text"
      :class [(when (= "license-key" (:field error)) "is-invalid")]
      :name  "license-key"
      :value license-key
      :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site form-key :license-key (.. % -target -value)])}]]

   [:div.form-group
    [:label "Password (if used)"]
    [:input.form-control
     {:type "text"
      :class [(when (= "password" (:field error)) "is-invalid")]
      :name "password"
      :value password
      :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site form-key :password (.. % -target -value)])}]]])

(defn no-site-plans-view [site upload-state opts]
  (let [qpe-dispatch (:qpe-dispatch opts)
        form-key :site-plan-form
        {:keys [license-key password]
         :as form-data} @(rf/subscribe [::state-subs/sidebar-form-data :site form-key])
        error @(rf/subscribe [::state-subs/sidebar-error :site])]
    [:form
     {:on-submit (fn [e]
                   (.preventDefault e)
                   (qpe-dispatch [::events/submit-site-plan-key site {:site-plan-key license-key
                                                                      :password password}]))}
     [:fieldset.form-group
      [:legend.h5.fw-normal "Connect to an existing Site Plan from Quuppa Customer Portal"]
      [site-plan-key-form form-key form-data error]
      [button
       {:variant "primary"
        :attr    {:type     "submit"
                  :disabled (or (empty? license-key)
                                (and upload-state (not= :error upload-state)))}}
       "Select"]]
     [c/error-alert error]]))

(defn select-existing-site-plan-view [site current-site-plan {existing-site-plans :result} opts]
  (let [qpe-dispatch (:qpe-dispatch opts)
        form-key :existing-site-plan
        plans-count (count existing-site-plans)
        current-site-plan-key (:key current-site-plan)
        imdf-site-plans (filter :has-imdf-data existing-site-plans)
        imdf-count (count imdf-site-plans)
        planner-enabled? (features/enabled? :planner)
        {:keys [site-plan-tab previous-site-plan-selection imdf-site-plan-selection license-key password]
         :or   {site-plan-tab                (if (> plans-count 1) :previous :new)
                previous-site-plan-selection current-site-plan-key}
         :as   form-data} @(rf/subscribe [::state-subs/sidebar-form-data :site form-key])
        error               @(rf/subscribe [::state-subs/sidebar-error :site])]
    [:div
     [tabs/tabs
      {:active-key site-plan-tab
       :class-name "mb-3"
       :fill true
       :on-select #(rf/dispatch [::state-events/set-sidebar-form-field :site form-key :site-plan-tab (keyword %)])}

      [tabs/tab
       {:title "From Portal"
        :event-key :new}
       [:form
        {:key "new"
         :on-submit (fn [e]
                      (.preventDefault e)
                      (qpe-dispatch [::events/submit-site-plan-key site {:site-plan-key license-key
                                                                         :password password}]))}
        [:fieldset.form-group
         [:legend.h5.fw-normal "Connect to an existing Site Plan from Quuppa Customer Portal"]
         [site-plan-key-form form-key form-data error]
         [button
          {:variant "primary"
           :attr    {:type     "submit"
                     :disabled (empty? license-key)}}
          "Change Site Plan"]]]]

      [tabs/tab
       {:title     (r/as-element [:<> "Select previous " [:span.badge.bg-primary.rounded-pill plans-count]])
        :event-key :previous}
       [:form
        {:key "previous"
         :on-submit (fn [e]
                      (.preventDefault e)
                      (qpe-dispatch [::events/select-site-plan-key site {:site-plan-key previous-site-plan-selection}]))}
        (for [{license-key :key :as site-plan} existing-site-plans
              :let [current-plan? (= previous-site-plan-selection license-key)]]
          ^{:key license-key}
          [side-plan-form-card-item form-key site-plan current-plan? :previous-site-plan-selection])
        [button
         {:variant "primary"
          :attr {:type "submit"
                 :disabled (and previous-site-plan-selection
                                (= previous-site-plan-selection current-site-plan-key))}}
         "Change Site Plan"]]]

      (when planner-enabled?
        [tabs/tab
         {:title     (r/as-element [:<> "Select IMDF " [:span.badge.bg-primary.rounded-pill imdf-count]])
          :event-key :imdf}
         [:form
          {:key "imdf"
           :on-submit (fn [e]
                        (.preventDefault e)
                        (qpe-dispatch [::events/select-site-plan-key site {:site-plan-key imdf-site-plan-selection}]))}
          (if (seq imdf-site-plans)
            (for [{plan-key :key :as site-plan} imdf-site-plans
                  :let [current-plan? (= imdf-site-plan-selection plan-key)]]
              ^{:key plan-key}
              [side-plan-form-card-item form-key site-plan current-plan? :imdf-site-plan-selection])
            [:p.text-muted "No site plans with IMDF data available."])
          [button
           {:variant "primary"
            :attr {:type "submit"
                   :disabled (or (empty? imdf-site-plan-selection)
                                 (= imdf-site-plan-selection current-site-plan-key))}}
           "Change Site Plan"]]])]
     [c/error-alert error]]))

(defn site-plan-sidebar [{site-id :id :as site} current-site-plan opts]
  (let [existing-site-plans (q/use-query events/site-plans-query {:site-id site-id})
        no-existing-site-plans? (and (not (:loading existing-site-plans))
                                     (empty? (:result existing-site-plans)))
        upload-state @(rf/subscribe [::state-subs/ui-state :site :sidebar :site-plan-upload])]
    [layout/sidebar
     [layout/sidebar-header
      {:title (if no-existing-site-plans?
                "Site Plan"
                "Change Site Plan")
       :on-close #(rf/dispatch [::events/close-site-plan-form])}]

     [layout/sidebar-content
      (if (:initial-load existing-site-plans)
        [:div [spinner] [:span "Loading Site plans..."]]
        (if no-existing-site-plans?
          [no-site-plans-view site upload-state opts]
          [select-existing-site-plan-view site current-site-plan existing-site-plans opts]))
      (case upload-state
        :validating [:div [spinner] [:span "Validating key..."]]
        :submitting [:div [spinner] [:span "Connecting..."]]
        [:div])]]))

(defn new-site-plan-sidebar [site project-id site-id]
  (let [new-site-plan-state @(rf/subscribe [::state-subs/ui-state :site :sidebar :new-site-plan-form])
        error (:error new-site-plan-state)
        form-data (:data new-site-plan-state)
        current-site-type (:site-type form-data)
        current-locator-type (:locator-type form-data)
        current-starting-point (:starting-point form-data)]
    [layout/sidebar
     ; kaosko 2025-05-09 - you could argue it's not anymore a sidebar if it takes 100% of the width but we want it to work
     ; the same way and really makes no sense to show any status of previous site plans
     ; when creating a new one. We also need space to show all the options and upload form
     {:style {:min-width "100%"}}
     [layout/sidebar-header
      {:title "New Site plan"
       :on-close #(rf/dispatch [::events/close-site-plan-form])}]

     [:form
      {:on-submit (fn [e]
                    (.preventDefault e)
                    (rf/dispatch [::events/create-site-plan project-id site-id]))}
      (when error
        [c/error-alert (:data error)])

      [layout/sidebar-content
       [:div.form-group
        [:h4 [:label "Plan name"]]
        [:input.form-control
         {:type      "text"
          :name      "site-plan-name"
          :value     (:name form-data)
          :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :name (.. % -target -value)])}]]

       [:h4 "Site type"]
       [:div.d-flex.flex-wrap.gap-3.flex-row
        {:style {:justify-content "space-between"}}
        [:div.form-group.flex-grow-1
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "site-type"
            :id        "site-type-industrial"
            :checked   (= current-site-type :industrial)
            :value     :industrial
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :site-type :industrial])}]
          [:label.form-check-label
           {:for "site-type-industrial"}
           "Industrial"]]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "site-type"
            :id        "site-type-office"
            :checked   (= current-site-type :office)
            :value     :office
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :site-type :office])}]
          [:label.form-check-label
           {:for "site-type-office"}
           "Office"]]]

        ; next to the site-type, there should be a radio selection for installation height using numeric input for arrows.
        ; If industrial is selected, the default height is 4.5m, if office is selected, the default height is 2.7m
        ; There should also be a third radio selection for locator type. For industrial, default locator type is Q35
        ; and for office, it's Q17
        [:div.form-group.flex-grow-1
         [:label "Installation height"]
         [:input.form-control
          {:type      "number"
           :name      "installation-height"
           :value     (:installation-height form-data)
           :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :installation-height (.. % -target -value)])}]]
        [:div.form-group.flex-grow-1
         [:label "Locator type"]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "locator-type"
            :id        "locator-type-q17"
            :checked  (= current-locator-type :Q17)
            :value     :Q17
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :locator-type :Q17])}]
          [:label.form-check-label
           {:for "locator-type-q17"}
           "Q17"]]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "locator-type"
            :id        "locator-type-q35"
            :checked   (= current-locator-type :Q35)
            :value     :Q35
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :locator-type :Q35])}]
          [:label.form-check-label
           {:for "locator-type-q35"}
           "Q35"]]]]
       [:hr]
       [:h4 "Starting point"]
       [:div.d-flex.flex-wrap.gap-3.flex-row
        {:style {:justify-content "space-between"}}
        [:div.form-group
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "starting-point"
            :id        "starting-point-floorplan"
            :checked   (= current-starting-point :floorplan)
            :value     :floorplan
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :starting-point :floorplan])}]
          [:label.form-check-label
           {:for "starting-point-floorplan"}
           "From a floorplan image"]]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "starting-point"
            :id        "starting-point-imdf"
            :value     :imdf
            :checked   (= current-starting-point :imdf)
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :starting-point :imdf])}]
          [:label.form-check-label
           {:for "starting-point-imdf"}
           "From an existing IMDF model"]]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "starting-point"
            :id        "starting-point-size-estimate"
            :value     :size-estimate
            :checked   (= current-starting-point :size-estimate)
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :starting-point :size-estimate])}]
          [:label.form-check-label
           {:for "starting-point-size-estimate"}
           "An empty rectange with a given size"]]
         [:div.form-check
          [:input.form-check-input
           {:type      "radio"
            :name      "starting-point"
            :id        "starting-point-copy-current"
            :value     :copy-current
            :checked   (= current-starting-point :copy-current)
            :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :starting-point :copy-current])}]
          [:label.form-check-label
           {:for "starting-point-copy-current"}
           "Make a copy of current Site plan"]]]


        (case current-starting-point
          :floorplan
          [:div.form-group.flex-grow-1
           [:label "Upload floorplan image"]
           [c/file-upload-component
            {:onupdatefiles (fn [files]
                              (when-let [file (first files)]
                                (rf/dispatch [::state-events/assoc-in [:site :sidebar :new-site-plan-form :pending-floorplan] (.-file file)])))
             ;:allowMultiple false
             ;:maxFiles 1
             ;:acceptedFileTypes ["image/*"]
             ;:error (get-in new-site-plan-state [:floorplan-upload :error])
             :labelIdle "Drop floorplan image here or click to browse"}]]
          :size-estimate
          [:div
           [:div.form-group
            [:label "Width (m)"]
            [:input.form-control
             {:type      "number"
              :name      "room-width"
              :value     (:room-width form-data)
              :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :room-width (.. % -target -value)])}]]
           [:div.form-group
            [:label "Length (m)"]
            [:input.form-control
             {:type      "number"
              :name      "room-length"
              :value     (:room-length form-data)
              :on-change #(rf/dispatch [::state-events/set-sidebar-form-field :site :new-site-plan-form :room-length (.. % -target -value)])}]]]
          nil)]
       [:button.btn.btn-primary.mx-2.px-4
        {:type "submit"}
        "Create New"]]]]))
